import { useTranslation } from 'react-i18next';
import { i18translation } from 'locale/translations/i18NsPaths';
import FormSwitch from '../FormSwitch/FormSwitch';

export interface LabeledToggleProps {
  name: string;
  dataTestId?: string;
  id?: string;
  disabled?: boolean;
  readOnly?: boolean;
  onChange?: (value: boolean) => void;
  ariaLabel?: string;
}

const LabeledToggle = ({
  name,
  id,
  disabled,
  readOnly,
  dataTestId,
  onChange,
  ariaLabel
}: LabeledToggleProps) => {
  const { t } = useTranslation();
  const keyPrefix = i18translation.createSubscription.sharedComponents;

  return (
    <FormSwitch
      name={name}
      id={id}
      dataTestId={dataTestId}
      disabled={disabled}
      readOnly={readOnly}
      onChange={onChange}
      titleOn={t(keyPrefix.on)}
      titleOff={t(keyPrefix.off)}
      ariaLabel={ariaLabel}
    />
  );
};

export default LabeledToggle;
